import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { DRAWINGS_EDITOR_TOUR_ID } from './editor';
import { DRAWINGS_LIST_TOUR_ID } from './list';
import {
  activityStep,
  bulkActionsStep,
  closeStep,
  combinedListStep,
  filePickerStep,
  markupFilterStep,
  pageNavStep,
  revisionPickerStep,
  searchFiltersStep,
  searchStep,
  shapesStep,
  uploadStep,
} from './steps';

export const DRAWINGS_COMBINED_TOUR_ID = 'drawings.combined';

registerTour({
  id: DRAWINGS_COMBINED_TOUR_ID,
  name: 'Drawings',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.DRAWINGS.id,
  alsoMarks: [DRAWINGS_LIST_TOUR_ID, DRAWINGS_EDITOR_TOUR_ID],
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Drawings',
      body:
        'A central place to view, mark up, and revise every drawing on the ' +
        'project. Upload PDFs and we\u2019ll auto-extract drawing numbers, ' +
        'titles, and disciplines so they organize themselves.',
    },
    uploadStep,
    searchFiltersStep,
    bulkActionsStep,
    combinedListStep,
    filePickerStep,
    revisionPickerStep,
    pageNavStep,
    shapesStep,
    markupFilterStep,
    activityStep,
    searchStep,
    closeStep,
  ],
});
